export default __webpack_public_path__ + "static/media/ArrowDown.da681b16.svg";